import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import ThemeToggle from './ThemeToggle';
import { ThemeContext } from '../contexts/ThemeContext';

const Header = ({ user, isAuthenticated, signOut, setIsUploading }) => {
  const { theme } = useContext(ThemeContext);
  const isDarkMode = theme === 'dark';
  
  return (
    <nav className="header-nav clearfix border-bottom border-light-gray" role="navigation">
      <div className="left">
        <a href="https://saptak.in" className="logo-link">
          <h1 className="header-title">
            <img 
              src={isDarkMode ? '/Saptak-Sen-w.lowres.png' : '/Saptak-Sen-b.lowres.png'}
              alt="Saptak Sen"
              className="w-auto h-10"
              onError={(e) => {
                console.log("Logo failed to load, falling back to text");
                const logoDiv = document.createElement('div');
                logoDiv.innerHTML = '<span style="font-weight: bold; font-size: 18px;">Saptak Sen</span>';
                e.target.parentNode.replaceChild(logoDiv, e.target);
              }}
            />
          </h1>
        </a>
      </div>
      <div className="right">
        <Link to="/instatrans" className="button button-transparent" title="Reel transcripts">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path fillRule="evenodd" d="M7 4a3 3 0 016 0v4a3 3 0 11-6 0V4zm4 10.93A7.001 7.001 0 0017 8a1 1 0 10-2 0A5 5 0 015 8a1 1 0 00-2 0 7.001 7.001 0 006 6.93V17H6a1 1 0 100 2h8a1 1 0 100-2h-3v-2.07z" clipRule="evenodd" />
          </svg>
        </Link>
        <ThemeToggle />
        {isAuthenticated && (
          <>
            <button
              onClick={() => setIsUploading(true)}
              className="button button-transparent"
              title="Upload"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM6.293 6.707a1 1 0 010-1.414l3-3a1 1 0 011.414 0l3 3a1 1 0 01-1.414 1.414L11 5.414V13a1 1 0 11-2 0V5.414L7.707 6.707a1 1 0 01-1.414 0z" clipRule="evenodd" />
              </svg>
            </button>
            <button
              onClick={signOut}
              className="button button-transparent"
              title="Sign Out"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M3 3a1 1 0 00-1 1v12a1 1 0 102 0V4a1 1 0 00-1-1zm10.293 9.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 10-1.414 1.414L14.586 9H7a1 1 0 100 2h7.586l-1.293 1.293z" clipRule="evenodd" />
              </svg>
            </button>
          </>
        )}
        {!isAuthenticated && (
          <Link
            to="/login"
            className="button button-transparent"
            title="Sign In"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z" clipRule="evenodd" />
            </svg>
          </Link>
        )}
      </div>
    </nav>
  );
};

export default Header;
